import React from 'react';
import Papa from 'papaparse';
import { useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { withErrorBoundary } from "../../../shared-components/ErrorBoundary";
import { Button, Card, Icon, DataGrid, Pagination, Toggle, Dialog, MessageBar, ProgressRing, TextField, InlineStatus } from "../SpaAdminScope";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../root-redux/RootState";
import { campaignCartListSelector } from "../redux/CampaignCartList.Selector.redux";
import { DataCartFilter } from "./Components/DataCartFilter";
import { createScope, dataGrid, partnerCenterTheme, tooltip } from "@harmony/enablers/react";
import { addToReviewList, clearReviewList, deleteFromReviewList, resolveReviewList, setInCartAndOutOfCart } from "../redux/CampaignById.redux";
import { postCampaignDetails, postCampaignInSilent } from "../../../services/SPAAdmin/CampaignById.api";
import { getAllPredictions, getPredictions, saveDatacartRecordsToFile, updateDataCartField } from "../../../services/SPAAdmin/CampaignDataCart.api";
import { resetPageNumber, setCartPageNum, setPendingReview, setViewResultsCount, showSpinner, updateSoftDelete } from "../redux/CampaignDataCart.redux";
import { Helper } from "../utils/Help";
import { CAMPAIGN_AUDIT_ESTIMATEDVALUE_FIELD, MessageTypes } from "../SPAConstants";
import { RequestStatus } from "../../../model/ServiceRequestStatus.model";
import { sendAreaReviewerNotification } from "../../../services/SPAAdmin/MEONotification.api";
import { postRelease } from "../../../services/PostRelease.api";
import { addNewWorkflow } from "../../workflows/workflow-by-id-redux/WorkflowById.actions.redux";
import { Environment, Release } from "../../../model/releases/Release.model";
import { setDatasetCache, UserMode } from "../redux/CacheHandler.redux";
import { FileUploadPopUp } from "../dataset/FileUploadPopup";
import { DatasetFileUploadModel, DatasetResponseType } from "../../../model/workflows/DatasetFileUpload.model";
import { setCurrentDatasetFileUploadState } from "../../workflows/workflows-redux/DatasetFileUpload.redux";
import { CampaignAuditHistoryModel, DataCartRowCustomData } from '../../../model/SPAModels/campaigns/campaign.Model';
import { Prediction } from '../../../model/preview-mergerule/Prediction.model';
import { getBulkDeleteTemplate } from '../../../services/GetDatasetUploadTemplate.api';
import { DownloadBulkDeleteLog } from '../../../services/utils/ExcelHandler';

interface IDataCart {
    nextPageEvent: (idx: number) => void
}

const DataCartC: React.FC<IDataCart> = ({nextPageEvent}) => {

    const scope = createScope({
        basePath: "https://harmonyenablers.microsoft.com/npm/@harmony/enablers/6.34.1",
        theme: partnerCenterTheme,
        reactInstance: React,
      });
    const Tooltip = scope.forReact(tooltip);
    const dispatchApp = useDispatch<AppDispatch>();
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [isAcceptDialogOpen, setIsAcceptDialogOpen] = useState<boolean>(false);
    const [isDeclineDialogOpen, setIsDeclineDialogOpen] = useState<boolean>(false);
    const [isDeleteAllOpen, setIsDeleteAllOpen] = useState<boolean>(false);
    const [isShareOpen, setIsShareOpen] = useState<boolean>(false);
    const [isDeleteDisabled, setIsDeleteDisabled] = useState<boolean>(true);
    const [message, setMessage] = useState<{type: MessageTypes, message: string, isOpen: boolean}|undefined>(undefined);
    const [openCreateNewDataset, setOpenCreateNewDataset] = useState(false);
    const [isMailLoading, setMailLoading] = useState<boolean>(false);
    const [isMailPossible, setMailPossible] = useState<number>(0);
    const [reviewerNames, setReviewerNames] = useState<any[]>([]);

    const dataGridRef = useRef<dataGrid>(null);
    const campaignCartList = useSelector(campaignCartListSelector);
    const campaignById = useSelector((state: RootState) => state.campaignById);
    const campaignDataCart = useSelector((state: RootState) => state.campaignDataCart);
    const workflowsBySubKeys = useSelector((state: RootState) => state.workflowsBySubKeys);
    const userSalesRoles = useSelector((state: RootState) => state.userSalesRoles);
    const environment = useSelector((state: RootState) => state.env.selectedEnvItem);
    const [isAddDisabled, setIsAddDisabled] = useState<boolean>(userSalesRoles.isApprover);
    const filteredCampaign = useSelector((state: RootState) => state.filteredCampaign);
    const deleteReviewList = useSelector((state: RootState) => state.campaignById.deleteReviewList);
    const userDetails = useSelector((state: RootState) => state.userDetails);
    const [isRemoveAccOpen, setIsRemoveAccOpen] = useState<boolean>(false);
    const [toBeDeletedRefs, setToBeDeletedRefs] = useState<string[]>([]);
    const [duplicateDeleteRecord, setDuplicateDeleteRecord] = useState<string[]>([]);
    const [fileTpidNotInDatacart, setFileTpidNotInDatacart] = useState<string[]>([]);
    const [selectedFileName, setSelectedFileName] = useState<string>('');
    const [bulkDeleteLogData, setBulkDeleteLogData] = useState<{ tpid: string, status: string }[]>([]);

    const handlePageChange = (e: any) => {
        dispatchApp(setCartPageNum(e.detail));
        if (e.detail % 10 === 0 && campaignDataCart.maxPageNumber < e.detail) {
            dispatchApp(getPredictions({}));
        }
    }

    const reviewerColumns = [
        {
            field: 'id',
            content: `No.`
        },
        {
            field: 'UserName',
            content: `User Name`
        },
        {
            field: 'MailId',
            content: `Mail Id`
        },
        {
            field: 'Area',
            content: `Areas`
        }
    ];

    const sendSPACompleteNotificationCall = (send: boolean) => {
        dispatchApp(sendAreaReviewerNotification(send)).unwrap().then((result) => {
            if (result && Object.hasOwn(result, 'Code')) {
                setMailLoading(false);
                setMailPossible(3);
            }
            else if(result && Object.keys(result).length > 0) {
                setMailLoading(false);
                setMailPossible(send ? 2 : 1);
                let reviewerList = [];
                for(var objectId in result) {
                    const row = result[objectId];
                    reviewerList.push({
                        UserName: row[0],
                        MailId: row[1],
                        Area: (row[2] || "").split(',').join(', ')
                    });
                }
                let rowCount = 1;
                reviewerList = reviewerList.sort((a, b) => a.UserName.localeCompare(b.UserName)).map(row => {
                    return {
                        id: rowCount,
                        cells: {
                            id: rowCount++,
                            UserName: row.UserName,
                            MailId: row.MailId,
                            Area: row.Area
                        }
                    }
                });
                setReviewerNames(reviewerList);
            } else {
                setMailLoading(false);
                setMailPossible(2);
            }
        }).catch((err) => {
            setMailLoading(false);
            setMailPossible(3);
            console.log(err);
        })
    }

    const saveCampaign = () => {
        dispatchApp(resetPageNumber());
        dispatchApp(postCampaignDetails())
            .unwrap()
            .then(() => {
                setMessage({type: 'success', message: "Successfully Updated the campaign Information", isOpen: true});
                //dispatchApp(getPredictions({}));
            });
    }

    const downloadDatacartRecords =  async () => {
        dispatchApp(getAllPredictions({}))
        .unwrap()
        .then(() => {
            dispatchApp(saveDatacartRecordsToFile(null));
        });
    }

    const markAccountsForDeletion = (csvData: any[], filterData: Prediction[]) => {
        const requiredHeaders = ["TPID"];
        if (csvData.length === 0) {
            setMessage({ type: 'error', message: 'CSV file is empty', isOpen: true });
            return;
        }
        const csvHeaders = Object.keys(csvData[0]);
        const hasRequiredHeaders = requiredHeaders.every(header => csvHeaders.includes(header));
        
        if (!hasRequiredHeaders) {
            setMessage({ type: 'error', message: 'CSV file is missing required headers', isOpen: true });
            return;
        }
        
        const tpidWithRef: {[key:string]:string} = {};
        for(let row of filterData) {
            const attributes = row["attributes"];
            let tpid = "", refId = "";
            for(let attrs of attributes) {
                if (attrs["key"].toLowerCase() === "referenceid") {
                    refId = attrs["value"];
                }
                if (attrs["key"].toLowerCase() === "tpid") {
                    tpid = attrs["value"];
                }
            }
            tpidWithRef[tpid] = refId;
        }
        const toBeDeletedRefIds = [];
        const fileTpidNotInDatacart = [];
        const duplicateDeleteRecord = [];
        const inCart = campaignById.campaign?.inCart;
        for(let row of csvData) {
            const tpid = row["TPID"];
            if (tpid) {
                if(!inCart?.includes(tpidWithRef[tpid])) {
                    fileTpidNotInDatacart.push(tpid); 
                    bulkDeleteLogData.push({tpid: tpid, status: "TPID not in datacart"}); 
                }
                else if(deleteReviewList.includes(tpidWithRef[tpid])) 
                {
                    duplicateDeleteRecord.push(tpid);
                    bulkDeleteLogData.push({tpid: tpid, status: "TPID already marked for deletion"});
                }
                else if (tpidWithRef[tpid] && !deleteReviewList.includes(tpidWithRef[tpid])) {
                    toBeDeletedRefIds.push(tpidWithRef[tpid]);
                    bulkDeleteLogData.push({tpid: tpid, status: "TPID marked for deletion successfully"});
                }
            }
        }
        setBulkDeleteLogData(bulkDeleteLogData);
        setToBeDeletedRefs(toBeDeletedRefIds);
        setFileTpidNotInDatacart(fileTpidNotInDatacart);
        setDuplicateDeleteRecord(duplicateDeleteRecord);
    }

    const fetchAllAccounts = (csvData: any[]) => {
        dispatchApp(getAllPredictions({}))
            .unwrap()
            .then((data) => {
                const [inCartResult, viewResult] = data;
                markAccountsForDeletion(csvData, (inCartResult || []).concat(viewResult));
            });
    }

    const handleFileChange = (event: any) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFileName(file.name);
            setMessage(undefined);
            Papa.parse(file, {
                complete: (result: { data: any[]; }) => {
                    fetchAllAccounts(result.data);
                },
                header: true,
            });
        }
    }
    
    const bulkDelete = () => {
        if (userSalesRoles.isApprover) {
            toBeDeletedRefs.forEach(id => dispatchApp(deleteFromReviewList(id)));
            dispatchApp(setViewResultsCount(-1 * toBeDeletedRefs.length));
            setIsAddDisabled(true);
            setSelectedFileName("");
            setToBeDeletedRefs([]);
            setIsRemoveAccOpen(false);
            setMessage({type: 'success', message: 'Records marked for deletion, please save your changes.', isOpen: true});
            return;
        }
    }

    const downloadFile = async (e: any) => {
        if (e.target.id === "downloadTemplate") {
            getBulkDeleteTemplate();
        } else if (e.target.id === "downloadLogFile") {
            DownloadBulkDeleteLog(bulkDeleteLogData,"BulkDeleteLog.csv");
        }
    }

    const isInvalidReviewerAddRecords = (srows: string[]|undefined = undefined) => {
        const rows = srows || selectedRows;
        if (userSalesRoles.isApprover && rows.length === 0) {
            return true;
        }
        let flag = false;
        rows.forEach(id => {
            const inCart = campaignById.campaign?.inCart.includes(id);
            const arList = campaignById.addReviewList.includes(id);
            const drList = campaignById.deleteReviewList.includes(id);
            if (arList || (inCart && !drList)) {
                flag = true;
            }
        });
        return flag;
    }

    const isInvalidReviewerDeleteRecords = (srows: string[]|undefined = undefined) => {
        const rows = srows || selectedRows;
        if (rows.length === 0) {
            return true;
        }
        let flag = false;
        if (userSalesRoles.isApprover) {
            rows.forEach(id => {
                const inCart = campaignById.campaign?.inCart.includes(id);
                const arList = campaignById.addReviewList.includes(id);
                const drList = campaignById.deleteReviewList.includes(id);
                if (drList || (!inCart && !arList)) {
                    flag = true;
                }
            });
        }
        return flag;
    }

    const onAddRecords = () => {
        if (!userSalesRoles.isApprover) {
            nextPageEvent(-1);
            return;
        }
        setIsAddDisabled(true);
        setIsDeleteDisabled(true);
        if (isInvalidReviewerAddRecords()) {
            setMessage({type: 'warning', message: "Invalid Selection: Cannot add record which already incart/Requested for addition!", isOpen: true})
        } else {
            selectedRows.forEach(id => dispatchApp(addToReviewList(id)));
            dispatchApp(setViewResultsCount(selectedRows.length));
        }
    }

    const onDeleteRecords = () => {
        setIsDeleteDisabled(true);
        if (userSalesRoles.isApprover && !isInvalidReviewerDeleteRecords()) {
            selectedRows.forEach(id => dispatchApp(deleteFromReviewList(id)));
            dispatchApp(setViewResultsCount(-1 * selectedRows.length));
            setIsAddDisabled(true);
            return;
        }
        dispatchApp(updateSoftDelete(selectedRows));
        const newInCart = (campaignById.campaign?.inCart || []).filter(id => !selectedRows.includes(id));
        dispatchApp(setInCartAndOutOfCart({
            InCart: newInCart,
            DataSets: (campaignById.campaign?.dataSets || []),
        }));
        dispatchApp(postCampaignInSilent());
        setIsAddDisabled(false);
    }

    const onDeleteAllRecords = () => {
        setIsDeleteAllOpen(false);
        dispatchApp(setInCartAndOutOfCart({
            InCart: [],
            DataSets: []
        }));
        dispatchApp(clearReviewList());
        saveCampaign();
    }

    const onAddAccounts = () => {
        const newWorkflowId = uuidv4().toString();
        const environments: Environment[] = [
          { environment: "dev", isDeployed: true },  { environment: "uat", isDeployed: true },  { environment: "prod", isDeployed: false }];
      
        const releaseData : Release = {
          environments: environments,
          timestamp: "",
          releaseId: uuidv4().toString(),
          workflowId: newWorkflowId,
          version: "1",
          id: uuidv4().toString(),
          type: "New Version",
          status: "New",
          scheduleCreated: false,
        };
        dispatchApp(postRelease({payload : releaseData, env: environment}));
        dispatchApp(addNewWorkflow({workflowId: newWorkflowId, subscriptionKey: "3A2504E0-4F89-11D3-9A0C-0305E82C3302", environment, modifiedBy: "", workflowType: "Dataset"}))
        dispatchApp(setCurrentDatasetFileUploadState({fileUploadObj :{} as DatasetFileUploadModel, responseType: DatasetResponseType.Idle}));
        dispatchApp(setDatasetCache({
            datasetId: undefined,
            mode: UserMode.CREATE
        }));
        setOpenCreateNewDataset(true);
        if(!openCreateNewDataset)
            dispatchApp(resetPageNumber());
    }

    const onRowSelect = (e: any) => {
        const rows = (dataGridRef.current!.selectedRows || []).map(detail => (detail.customData as DataCartRowCustomData).id as string);
        setSelectedRows(rows);
        setIsAddDisabled(isInvalidReviewerAddRecords(rows));
        setIsDeleteDisabled(isInvalidReviewerDeleteRecords(rows));
    }

    const handlePendingReview = () => {
        dispatchApp(setPendingReview(!campaignDataCart.pendingReview));
        dispatchApp(getPredictions({}));
    }

    const acceptReviewItems = () => {
        setIsAcceptDialogOpen(false);
        dispatchApp(resolveReviewList(selectedRows));
        saveCampaign();
        dispatchApp(setPendingReview(false));
    }

    const declineReviewItems = () => {
        setIsDeclineDialogOpen(false);
        dispatchApp(clearReviewList(selectedRows));
        saveCampaign();
        dispatchApp(setPendingReview(false));
    }
    const updateEstimatedValue = (value:any, id:string) => {
        if(value === "") {
            setMessage({type: 'error', message: "Estimated value cannot be blank", isOpen: true})
            dispatchApp(getPredictions({}));
            return;
        } else if(isNaN(value) || value <= 0) {
            setMessage({type: 'error', message: "Estimated value should be a number and greater than 0", isOpen: true})
            dispatchApp(getPredictions({}));
            return;
        } 
        var campaignAuditHistory:CampaignAuditHistoryModel = new CampaignAuditHistoryModel();
        campaignCartList.rows.filter(row => row.id === parseInt(id)).map(row => {
        campaignAuditHistory.id =  uuidv4().toString();
        campaignAuditHistory.oldValue = row.cells[CAMPAIGN_AUDIT_ESTIMATEDVALUE_FIELD]
        campaignAuditHistory.newValue = value;
        campaignAuditHistory.fieldName = CAMPAIGN_AUDIT_ESTIMATEDVALUE_FIELD;
        campaignAuditHistory.modifiedBy = userDetails?.localAccountId;
        campaignAuditHistory.sourceId = (row.customData as DataCartRowCustomData).sourceId;
        campaignAuditHistory.referenceId = (row.customData as DataCartRowCustomData).referenceId;
        campaignAuditHistory.workflowId = campaignById.campaign?.config.workflowId??"";
        campaignAuditHistory.version = campaignById.campaign?.version??0;

    });
    dispatchApp(updateDataCartField(campaignAuditHistory)).unwrap()
    .then((response) => { 
        if(response) {
        dispatchApp(getPredictions({}));
    }
    else{
        setMessage({type: 'error', message: "Error while updating the estimated value", isOpen: true})
        dispatchApp(getPredictions({}));
    }
    });
        
    }
    return (
        <>
            {
                message?.isOpen &&
                <MessageBar appearance={message.type} open={message.isOpen} onHeHide={() => setMessage(undefined)}>
                    {message.message}
                </MessageBar>
            }
            <Card className='spa-query-card'>
                <span slot="heading">
                    <div className="spa-query-card-command">
                        <Button appearance="command" onClick={onAddRecords} disabled={campaignDataCart.pendingReview || isAddDisabled}>
                            <Icon slot="start" name="add"></Icon>Add Records
                        </Button>
                        <Button appearance="command" onClick={onDeleteRecords} disabled={campaignDataCart.pendingReview || isDeleteDisabled}>
                            <Icon slot="start" name="cancel"></Icon>Delete Records
                        </Button>
                        {!userSalesRoles.isApprover &&
                            <Button appearance="command" onClick={() => setIsDeleteAllOpen(true)} disabled={campaignDataCart.pendingReview || !isDeleteDisabled || (campaignById.campaign?.inCart || []).length === 0}>
                                <Icon slot="start" name="delete"></Icon>Delete all Records
                            </Button>
                        }
                        {userSalesRoles.isApprover ?
                            <Button appearance="command" onClick={saveCampaign} disabled={!campaignById.unsavedChanges}>
                                <Icon slot="start" name="save"></Icon>Save changes
                            </Button>
                            :
                            (campaignById.campaign?.reviewList || []).some(rList => rList.list.length > 0) && 
                            <>
                                <Button appearance="command" onClick={() => setIsAcceptDialogOpen(true)} disabled={!campaignDataCart.pendingReview || campaignCartList.loading}>
                                    <Icon slot="start" name="save"></Icon>Accept
                                </Button>
                                <Button appearance="command" onClick={() => setIsDeclineDialogOpen(true)} disabled={!campaignDataCart.pendingReview || campaignCartList.loading}>
                                    <Icon slot="start" name="disconnectdevice"></Icon>Decline
                                </Button>
                                <Toggle onHeChange={() => handlePendingReview()} checked={campaignDataCart.pendingReview} disabled={campaignCartList.loading}>
                                    <span slot="checked-message">Pending Review ({campaignById.addReviewList.length + campaignById.deleteReviewList.length})</span>
                                    <span slot="unchecked-message">Pending Review ({campaignById.addReviewList.length + campaignById.deleteReviewList.length})</span>
                                </Toggle>
                            </>
                        }
                        <DataCartFilter/>
                        <Button appearance="command"  onClick={downloadDatacartRecords} disabled={filteredCampaign?.status === RequestStatus.loading || campaignDataCart?.requestStatus === RequestStatus.loading}>
                            <Icon slot="start" name="excellogo"></Icon>Download Records
                        </Button>
                        { 
                            userSalesRoles.isApprover &&
                            <>
                            <Button id="add-accounts" appearance="command" onClick={onAddAccounts}>
                                <Icon slot="start" name="appicondefaultadd"></Icon>Add Accounts
                                <Tooltip anchor="add-accounts" fixedPlacement={true} placement='bottom'>
                                    Add Accounts - This process may take around 5 minutes.
                                </Tooltip>
                            </Button>

                            <Button id="remove-accounts" appearance="command" onClick={() => setIsRemoveAccOpen(true)}>
                                <Icon slot="start" name="removecontent"></Icon>Remove Accounts
                                <Tooltip anchor="remove-accounts" fixedPlacement={true} placement='bottom'>
                                {userSalesRoles.isApprover ? "Mark Accounts for deletion - CA DRI needs to accept the changes to effect" :
                                "Remove Accounts from Data Cart."}
                                </Tooltip>
                            </Button>
                        </>
                        }
                        {
                            userSalesRoles.isApprover ?
                            <p style={{ marginLeft: 'auto', color: 'silver', top: '10px', fontSize: '13px', position: 'relative'}}>(Rows: {campaignCartList.rows.length})</p>
                            :
                            <Button appearance="command" style={{ marginLeft: 'auto', position: 'relative'}} onClick={() => {
                                setMailLoading(true);
                                sendSPACompleteNotificationCall(false);
                                setIsShareOpen(true);
                            }} disabled={campaignDataCart.pendingReview}>
                                <Icon slot="start" name="share"></Icon>Share
                            </Button>
                        }
                    </div>
                </span>

                <div>
                    <DataGrid
                        rows={campaignCartList.rows}
                        columns={campaignCartList.columns}
                        select="multiple"
                        loading={userSalesRoles.requestStatus === RequestStatus.loading || campaignById.requestStatus === RequestStatus.loading || campaignCartList.loading || Helper.isLoadingStatus(campaignById.requestStatus, workflowsBySubKeys.status)}
                        onHeRowSelectChange={onRowSelect}
                        onHeSelectAllChange={onRowSelect}
                        onHeBulkSelect={onRowSelect}
                        ref={dataGridRef}
                    >
                        <span slot="no-records">No records were found.</span>
                        {campaignCartList.rows.map(row => {
                         return <>
                            {
                                <>
                                    <span slot={`Add/Remove-Accounts-${row.id}`}>{(row.cells["Add/Remove-Accounts"] === "Add" && userSalesRoles.isApprover) ?  'In-Cart' : row.cells["Add/Remove-Accounts"]}</span>
                                    {/* Visually hidden label for accessibility */}
                                     
                                    <TextField   label={`Estimated Value for row ${row.id}`}
                                    slot={`EstimatedValue-${row.id}`} value={Helper.formatNumberWithCommas(row.cells["EstimatedValue"])} 
                                    disabled={!(userSalesRoles.isSpaAdmin || userSalesRoles.isSpaUser)}
                                    onHeChange={(e) => {
                                        updateEstimatedValue(Helper.stripCommas((e.currentTarget as HTMLInputElement).value), row.id);
                                    }} >
                                  <span slot="label" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', border: 0 }}>{`Estimated Value for Account ${row.cells["AccountName"]}`}</span>
                                </TextField>
                                </>
                            }
                            </>
                            
                        })}  
                    </DataGrid>
                    <Pagination
                        slot="pagination"
                        value={campaignDataCart.pageNum}
                        pageCount={campaignCartList.totalPage}
                        onHePageChange={handlePageChange}
                    />
                </div>
            </Card>
            

            <Dialog heading="Accept:" open={isAcceptDialogOpen} onHeAfterHide={() => setIsAcceptDialogOpen(false)}>
                <p>
                    Please click ok to accept the reviewed accounts<br />
                </p>
                <Button slot="footer" appearance="primary" onClick={acceptReviewItems}>Ok</Button>
                <Button slot="footer" onClick={() => setIsAcceptDialogOpen(false)}>Close</Button>
            </Dialog>

            <Dialog heading="Decline:" open={isDeclineDialogOpen} onHeAfterHide={() => setIsDeclineDialogOpen(false)}>
                <p>
                    Would you like to decline accounts that are pending for review?<br />
                </p>
                <Button slot="footer" appearance="primary" onClick={declineReviewItems}>Yes</Button>
                <Button slot="footer" onClick={() => setIsDeclineDialogOpen(false)}>No</Button>
            </Dialog>

            <Dialog heading="Area Reviewer Notification:" className={"AreaReviewerPopup"} open={isShareOpen} onHeAfterHide={() => setIsShareOpen(false)}>
                <div style={{ marginBottom: "10px" }}>
                    {
                        !isMailLoading && isMailPossible === 1 && <p>Click 'Send' to notify all the users listed below for review.</p>
                    }
                    {
                        isMailLoading && <ProgressRing label="Loading..." labelPlacement="end" indeterminate></ProgressRing>
                    }
                    {
                        !isMailLoading && isMailPossible === 2 && <InlineStatus type="complete">Mail Sent to the below Users</InlineStatus>
                    }
                    {
                        (isMailPossible === 1 || isMailPossible === 2) && <DataGrid rows={reviewerNames} columns={reviewerColumns}></DataGrid>
                    }
                    {
                        !isMailLoading && isMailPossible === 3 ? <InlineStatus type="error">Unable to send mail: No users found</InlineStatus> : <></>
                    }
                </div>
                {
                    isMailPossible !== 2 && isMailPossible !== 3 &&
                    <>
                        <Button slot="footer" appearance="primary" disabled={isMailLoading} onClick={() => {
                            setMailLoading(true);
                            sendSPACompleteNotificationCall(true);
                        }}>Send</Button>
                        <Button slot="footer" onClick={() => setIsShareOpen(false)}>Cancel</Button>
                    </>
                }
            </Dialog>

            <Dialog heading="Delete All:" open={isDeleteAllOpen} onHeAfterHide={() => setIsDeleteAllOpen(false)}>
                <p>
                    You are attempting to delete all the <b>{(campaignById.campaign?.inCart||[]).length}</b> accounts from Data cart<br />
                </p>
                <Button slot="footer" appearance="secondary" onClick={onDeleteAllRecords} style={{backgroundColor: '#dc3545', color: 'white'}}>Delete All ({(campaignById.campaign?.inCart||[]).length})</Button>
                <Button slot="footer" onClick={() => setIsDeleteAllOpen(false)}>No</Button>
            </Dialog>
            
            <Dialog heading="Remove Accounts" open={isRemoveAccOpen} onHeAfterHide={() => {
                setDuplicateDeleteRecord([]);
                setToBeDeletedRefs([]);
                setFileTpidNotInDatacart([]);
                setSelectedFileName("");
                setToBeDeletedRefs([]);
                setIsRemoveAccOpen(false);
            }}>
                {toBeDeletedRefs.length === 0 && duplicateDeleteRecord.length == 0 && fileTpidNotInDatacart.length == 0 && campaignDataCart.allPredictionsStatus !== RequestStatus.loading &&
                    <>
                        <p>
                        {userSalesRoles.isApprover ? "Upload csv file containing TPID list to be marked for Deletion" :
                                "Upload csv file containing TPID list to be deleted"}
                            <br />
                        </p>
                        <div style={{display: "flex" }}>
                            <TextField style={{width: "300px", cursor: 'pointer'}} clearable value={selectedFileName} placeholder="Select a file to upload"
                                onClick={() => { 
                                    const fileInput = document.getElementById("file-input") as HTMLInputElement;
                                    fileInput.value = "";
                                    fileInput.click();
                                }} onHeClear={() => {
                                    setSelectedFileName("");
                                    setToBeDeletedRefs([]);
                                    setMessage(undefined);
                                }}/>
                            <div id={'custom-upload-btn'}>
                                <input type="file" id="file-input" onChange={handleFileChange} accept=".csv"
                                    hidden />
                                <label htmlFor="file-input" style={{ marginRight: "5px", color: 'var(--he-color-primary-700)' }}>
                                <Icon className="custom-button" style={{marginLeft:'20px'}} name="upload"/>
                                </label>
                            </div>
                        </div>
                        {message?.type == "error" && <p style={{color: "red"}}>Error: {message.message}</p>}
                        <div style={{ marginTop: "10px", marginRight: "7px"}}>
                            <Icon name='info' id={'downloadTemplate'} style={{ cursor: "pointer", color: "#0078D4" }}></Icon>
                            <Tooltip anchor="downloadTemplate">The standard template can be downloaded here</Tooltip>
                            <Button appearance="link" id={'downloadTemplate'} onClick={downloadFile} style={{ color: "#0b62e4"}}>Download Template</Button>
                        </div>
                    </>
                }
                {
                    campaignDataCart.allPredictionsStatus === RequestStatus.loading &&
                    <ProgressRing label="Processing accounts..." labelPlacement="end" indeterminate></ProgressRing>
                }
                {
                    toBeDeletedRefs.length > 0 &&
                    <>
                        <MessageBar appearance="warning" open={fileTpidNotInDatacart.length > 0}>
                            {fileTpidNotInDatacart.length > 0 && (
                                <>
                                    <b>{fileTpidNotInDatacart.length}</b> accounts uploaded in file are not present in datacart.<br />
                                </>
                            )}
                        </MessageBar>
                        {fileTpidNotInDatacart.length > 0 && (
                            <p>
                                <b>{fileTpidNotInDatacart.length}</b> accounts uploaded in file are not present in datacart.<br />
                            </p>
                        )}
                        {duplicateDeleteRecord.length > 0 && (
                            <p>
                                <b>{duplicateDeleteRecord.length}</b> accounts are already marked as deleted.<br />
                            </p>
                        )}
                        
                        <p>
                            Do you want to proceed to mark <b>{toBeDeletedRefs.length}</b> accounts for deletion ?<br />
                        </p>
                        
                        <div style={{ marginTop: "10px", marginRight: "7px"}}>
                            <Icon name='info' id={'downloadLogFile'} style={{ cursor: "pointer", color: "#0078D4" }}></Icon>
                            <Tooltip anchor="downloadLogFile">Delete log of uploaded file can be downloded here</Tooltip>
                            <Button appearance="link" id={'downloadLogFile'} onClick={downloadFile} style={{ color: "#0b62e4"}}>Delete Log</Button>
                        </div>
                        <Button slot="footer" appearance="primary" onClick={() => {bulkDelete()}}>Proceed</Button>
                        <Button slot="footer" appearance="secondary" onClick={() => {
                            setSelectedFileName("");
                            setToBeDeletedRefs([]);
                            setIsRemoveAccOpen(false);
                            setDuplicateDeleteRecord([]);
                            setToBeDeletedRefs([]);
                            setFileTpidNotInDatacart([]);
                        }}>Cancel</Button>
                    </>
                }
                {
                    toBeDeletedRefs.length == 0 && (duplicateDeleteRecord.length > 0 || fileTpidNotInDatacart.length > 0) &&
                    <>
                        <MessageBar appearance="warning" open={fileTpidNotInDatacart.length > 0}>
                            {fileTpidNotInDatacart.length > 0 && (
                                <>
                                    All accounts uploaded in file are already marked deleted.<br />
                                </>
                            )}
                        </MessageBar>
                        {fileTpidNotInDatacart.length > 0 && (
                            <p>
                                <b>{fileTpidNotInDatacart.length}</b> accounts uploaded in file are not present in datacart.<br />
                            </p>
                        )}
                        {duplicateDeleteRecord.length > 0 && (
                            <p>
                                All <b>{duplicateDeleteRecord.length}</b> accounts are already marked as deleted.<br />
                            </p>
                        )}
                        <div style={{ marginTop: "10px", marginRight: "7px"}}>
                            <Icon name='info' id={'downloadLogFile'} style={{ cursor: "pointer", color: "#0078D4" }}></Icon>
                            <Tooltip anchor="downloadLogFile">Delete log of uploaded file can be downloded here</Tooltip>
                            <Button appearance="link" id={'downloadLogFile'} onClick={downloadFile} style={{ color: "#0b62e4"}}>Delete Log</Button>
                        </div>
                        <Button slot="footer" appearance="secondary" onClick={() => {
                            setSelectedFileName("");
                            setToBeDeletedRefs([]);
                            setIsRemoveAccOpen(false);
                            setDuplicateDeleteRecord([]);
                            setToBeDeletedRefs([]);
                            setFileTpidNotInDatacart([]);
                        }}>Cancel</Button>
                    </>
                }
            </Dialog>
            
            {openCreateNewDataset && (
                <FileUploadPopUp openCreateNewDataset={openCreateNewDataset} setOpenCreateNewDataset={setOpenCreateNewDataset} areaIfApprover={userSalesRoles.isApprover ? (userSalesRoles.userDetails.areas || []).join(",") :""}/>
            )} 
        </>
    )
};

export const DataCart = withErrorBoundary('Campaign: DataCart', DataCartC);